import React from 'react';
import { PatientCareCenterNoteGoalsBody } from 'PatientCareCenter/Note/Goals'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';


class PatientCareCenterNoteGoals extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='goals' name='Goals' refProp={this.props.refProp}>
                <PatientCareCenterNoteGoalsBody subjectiveRefProp={this.props.subjectiveRefProp} />
            </PatientCareCenterNoteSection>
        );
    }

}

export { PatientCareCenterNoteGoals };

